import React from "react";

import { Label } from "@busbud/horizon";
import type * as UDM from "@busbud/int-schemas/udm";

import { useAppContext } from "@app/helpers/hooks";
import type { CurrencyCode } from "@app/types/currency";
import type { PassengerSeatSelectionInstance } from "@app/types/seat-selection-types";

import type { SeatPrices } from "./seat-price";

import { SeatPrice } from "./seat-price";

interface Props {
  currency: CurrencyCode;
  prices: SeatPrices;
  passengers: PassengerSeatSelectionInstance[];
  selected_seats: UDM.SeatCell[];
  segment_id: string;
}

export const SummaryPrice: React.FC<Props> = ({
  currency,
  prices,
  passengers,
  selected_seats,
  segment_id
}) => {
  const { translator } = useAppContext();

  return (
    <div className="flex flex-col gap-050">
      <Label fontWeight="bold" size="md" className="text-color-primary" as="p">
        {translator.t("!checkout.seat-selection.total-price")}
      </Label>
      <Label
        size="xxl"
        class="text-color-tertiary"
        as="p"
        fontWeight="bold"
        data-test-id="seat-price"
      >
        <SeatPrice
          currency={currency}
          prices={prices}
          passengers={passengers}
          selected_seats={selected_seats}
          segment_id={segment_id}
        />
      </Label>
    </div>
  );
};
